import { render, staticRenderFns } from "./ColaboradorInterativo.vue?vue&type=template&id=06c7f264&"
import script from "./ColaboradorInterativo.vue?vue&type=script&lang=js&"
export * from "./ColaboradorInterativo.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradorInterativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports